module.exports = "/_next/static/images/browser-is-not-supported-05b7dc02279f263639f09adbfe413e9f.svg";